module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0133.jpg?v=df5f381b";